class subscriptionWidget extends HTMLElement {
  constructor() {
    super();

    const purchaseWrapper = this.querySelector(".purchase_options_wrapper");
    const sellingPlanInput = this.querySelector('[name="selling_plan"]');
    const sellingPlanSelectors = this.querySelectorAll(
      ".selling_plan_selector",
    );

    purchaseWrapper?.addEventListener("click", (e) => {
      const target = e.target.closest(".subscribe_and_save_widget, .one_time");
      if (!target) return;

      if (target.classList.contains("subscribe_and_save_widget")) {
        const selectedPlan = target.querySelector(
          ".selling_plan_selector",
        )?.value;
        if (selectedPlan && sellingPlanInput) {
          sellingPlanInput.value = selectedPlan;
        }
        purchaseWrapper.setAttribute(
          "data-purchase-option",
          "subscribe_and_save",
        );
      } else if (target.classList.contains("one_time")) {
        if (sellingPlanInput) {
          sellingPlanInput.value = "";
        }
        purchaseWrapper.setAttribute("data-purchase-option", "one_time");
      }
    });

    // Sync all selling plan selectors
    sellingPlanSelectors.forEach((selector) => {
      selector.addEventListener("change", (e) => {
        const newValue = e.target.value;

        // Update all other selectors and the hidden input
        sellingPlanSelectors.forEach((otherSelector) => {
          if (otherSelector !== e.target) {
            otherSelector.value = newValue;
          }
        });

        if (sellingPlanInput) {
          sellingPlanInput.value = newValue;
        }
      });
    });
  }
}

customElements.define("subscription-widget", subscriptionWidget);
